// profile.js
import React from 'react';
import { Well } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ProfileForm, ChangePassword } from './Forms';

const Profile = connect(state => ({ user: state.users.user }))(({ user }) => {
  if (user !== null) {
    return (
      <div className="container-fluid columns account account-content">
        <div className="col col-side">
          <nav className="side-nav">
            <ul>
              <li className="side-nav-item js-orders">
                <Link to="/orders">Your orders</Link>
              </li>
              <li className="side-nav-item active js-account">
                <Link to="/profile">Your account</Link>
              </li>
              <li className="side-nav-item js-pics">
                <Link to="/library">Your pics</Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className="container">
          <h1>
            Your details <small>edit your profile</small>
          </h1>
          <Well className="account-well">
            <h2>Account details</h2>
            <ProfileForm />
          </Well>
          <ChangePassword />
        </div>
      </div>
    );
  } else {
    return (
      <div className="container">
        <h1>You need to login</h1>
        <Well className="account-well" bsSize="large">
          <p>Hit the 'Log in' button in the bar up there</p>
        </Well>
      </div>
    );
  }
});
export default Profile;



// WEBPACK FOOTER //
// ./src/comps/Profile/Profile.js